import { List } from 'immutable';

import { BadRequestError, NotFoundError } from '../lib/APIClient';
import { resolve, resolveAll } from '../helpers/LinkMapper';
import { RAILCARD1617_CODE, Railcard1617Errors } from '../constants/AppConstants';
import APIClient from '../lib/APIClient';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import AccountRailcard from '../records/AccountRailcard';
import RailcardValidationResponse from '../records/RailcardValidationResponse';

const Railcard1617Service = {
    getBaseUrl(user) {
        return Railcard1617Service.getBaseUrlFromId(user.id);
    },

    getBaseUrlFromId(userId) {
        return `/customers/${userId}`;
    },

    async getRailcards(user) {
        try {
            const endpoint = `${this.getBaseUrl(user)}/season-railcards`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            return resolveAll(response.result).as(AccountRailcard);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return new List();
        }
    },

    async linkToAccount({ firstName, lastName, railcardNumber, expiryDate, syncWithKeygo = false, user }) {
        try {
            const railcard = {
                firstName,
                lastName,
                railcardNumber: railcardNumber,
                railcardCode: RAILCARD1617_CODE,
                syncWithKeygo,
                expiryDate
            };

            const endpoint = `${this.getBaseUrl(user)}/railcards`;
            const response = await AuthenticatedAPIClient.postForm(endpoint, railcard);
            return response;
        } catch (error) {
            if (error instanceof BadRequestError) {
                console.error('linkToAccouunt BadRequestError:', error.message, error.body);
                const hasErrors = error.body && error.body.errors && error.body.errors.length;
                const isRailcardAlreadyExistError = hasErrors && error.body.errors[0].message.includes(Railcard1617Errors.ALREADY_EXISTS);

                if (isRailcardAlreadyExistError) {
                    throw { message: 'booking.railcard1617.errors.alreadyExists' };
                }

                throw { message: 'booking.railcard1617.errors.unknown' };
            } else if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return null;
        }
    },

    async syncWithKeyGo({ railcardId, userId }) {
        try {
            const endpoint = `${this.getBaseUrlFromId(userId)}/season-railcards/${railcardId}/sync`;
            const response = await AuthenticatedAPIClient.post(endpoint);
            return response;
        } catch (error) {
            if (error instanceof BadRequestError) {
                console.error('syncWithKeyGo BadRequestError:', error.message, error.body);
            } else if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return null;
        }
    },

    // eslint-disable-next-line no-unused-vars
    async validate({ firstName, lastName, railcardNumber, expiryDate }) {
        try {
            const endpoint = `/customers/season-railcards/validate`;
            let response = await APIClient.post(endpoint, { railcardNumber, lastName, expiryDate });
            return resolve(response.result).as(RailcardValidationResponse);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return false;
        }
    }
};

export default Railcard1617Service;
